import { allowGoogleAnalytics, G_ANALYTICS_TAG } from './analytics';
import { deleteCookie, getCookie } from './helper';

export const COOKIES_MODAL_KEY = 'ck_modal';
export const COOKIES_MODAL_DURATION = 30;

export const COOKIES_ANALYTICS_KEY = 'ck_analytics_allow';
export const COOKIES_ANALYTICS_DURATION = 30;


export const necessaryCookies = [
    {
        name: COOKIES_MODAL_KEY,
        description: 'Cookie para validar el consentimiento de cookies',
        duration: `${COOKIES_MODAL_DURATION} dias`,
        provider: 'shophos.es',
    },
    {
        name: COOKIES_ANALYTICS_KEY,
        description: 'Cookie para validar el consentimiento de cookies analiticas',
        duration: `${COOKIES_ANALYTICS_DURATION} dias`,
        provider: 'shophos.es',
    },
];

export const optionalCookieGroups = [
    {
        name: 'Analíticas',
        key: COOKIES_ANALYTICS_KEY,
        description:
            'Utilizamos cookies analíticas para entender cómo los visitantes interactúan con nuestro sitio web. Estas cookies nos ayudan a recopilar información sobre el número de visitantes, las páginas más visitadas y el comportamiento de navegación, permitiéndonos mejorar la experiencia del usuario.',
        days: COOKIES_ANALYTICS_DURATION,
        cookies: [
            { name: '_ga', description: 'Identifica usuarios únicos', duration: '2 años', provider: 'Google' },
            { name: `_ga_TEDBTZ176T`, description: 'Diferencia usuarios', duration: '2 años', provider: 'Google' },
        ],
    },
];

export const parseCookies = async () => {
    const ack = await getCookie(COOKIES_ANALYTICS_KEY);
    const allowAnalytics = Boolean(ack && ack == '1');
    await analyticsCookies(allowAnalytics);
};

const analyticsCookies = async(accept) => {
    allowGoogleAnalytics(accept);
    if (!accept) {
        await deleteCookie('_ga');
        await deleteCookie(`_ga_TEDBTZ176T`);
    }
};
